<template>
  <!--  <div>-->
  <!--    <h3>{{project.name}}</h3>-->
  <!--  </div>-->

  <v-card class="" width="300">
    <v-img v-auth-image="bannerImageUrl" class="white--text" height="200px">
      <v-card-title class="align-end fill-height">
        {{ project.name }}
      </v-card-title>
    </v-img>

    <v-card-text
      class="pb-0 mb-4 text--primary card_text_size"
      v-html="descriptionText"
    ></v-card-text>

    <v-card-actions class="v_card">
      <!-- <v-btn text color="white" @click="projectExport(project.id)"
        >Export</v-btn
      > -->
      <v-spacer></v-spacer>
      <v-btn class="v_btn" text color="orange" @click="projectClick(project.id)"
        >Explore</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
const fileDownload = require('js-file-download')
import ProjectsService from '@/services/ProjectsService'
import Enums from '../helpers/Enums'
export default {
  props: {
    project: Object
  },
  methods: {
    getMediaContent: function(media) {
      if (media)
        this.descriptionText = media.textualContent.replace(
          /(\\r)*\\n/g,
          '<br>'
        )
    },
    projectClick: async function(projectId) {
      await this.$store.dispatch('BreadcrumbsStore/clear')
      this.$router.push('/projects/' + projectId).catch(err => {})
    },
    fetchMedia: async function(projectId) {
      let res = await ProjectsService.getProjectMedia(projectId, {
        mediaTypeId: Enums.MediaType.project_text_description
      })
      return res
    },
    projectExport: async function(projectId) {
      const response = await ProjectsService.getExportedProject({
        id: projectId,
        name: 'export.json'
      })

      fileDownload(JSON.stringify(response), 'export.json')
    }
  },
  data: function() {
    return {
      bannerImageUrl: '',
      descriptionText: ''
    }
  },
  created: function() {
    // const data = this.fetchMedia(this.$props.project.id)
    // data.then(res => {
    //   this.getMediaContent(res.data[0])
    // })
  }
}
</script>

<style scoped>
.v_btn {
  right: 0;
  bottom: 0;
  position: absolute;
  margin: 15px;
}
.v_card {
  padding: 25px;
}
.card_text_size {
  max-height: 80px;
  overflow: hidden;
}
</style>
